import { render } from "./Editor.vue?vue&type=template&id=50a77231&scoped=true"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"

import "./Editor.vue?vue&type=style&index=0&id=50a77231&scoped=true&lang=css"

import exportComponent from "/Users/xuesinuo/git/youtugz-backend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a77231"]])

export default __exports__